import { css, html, LitElement, nothing } from 'lit';
import { getGlobalStyleSheets } from '../../global-styles';
import { AtlFormInputGroupProps } from './form.props';
import { AtlIconClassFactory } from '../icon/icon.component';
import { InputGroupTextType } from './form.types';
import { IconEnums } from '../icon';

export abstract class AtlFormInputBase extends LitElement {
   declare inputGroup?: AtlFormInputGroupProps;

   static styles = [
      ...getGlobalStyleSheets(),
      css`
         :host {
            display: block;
         }
         .atl-form-input {
            flex: 0 1 100%;
         }
         .atl-form-input-clear {
            position: relative;
            right: 25px;
            margin-top: 12px;
            cursor: pointer;
         }
      `,
   ];

   static properties = {
      inputGroup: {
         attribute: 'input-group',
         type: Object,
      },
   };

   protected abstract _renderInput(): unknown;

   private _renderInputGroupIcon() {
      if (!this.inputGroup?.groupTextIconName) return nothing;

      return html`<i
         class="${AtlIconClassFactory({
            iconSource: IconEnums.IconSource.FontAwesome,
            iconName: this.inputGroup?.groupTextIconName,
         }).join(' ')}"
      ></i>`;
   }

   private _renderInputGroupText = (textType: InputGroupTextType) => {
      if (!this.inputGroup) return nothing;
      if (!this.inputGroup.groupTextLabel && !this.inputGroup.groupTextIconName)
         return nothing;

      const tt = this.inputGroup.groupTextType || InputGroupTextType.Append;
      if (tt != textType) return nothing;

      return html`
         <span class="input-group-text">
            ${this._renderInputGroupIcon()}
            ${this.inputGroup.groupTextLabel
               ? html`${this.inputGroup.groupTextLabel}`
               : nothing}
         </span>
      `;
   };

   render() {
      if (!this.inputGroup) {
         return this._renderInput();
      }

      return html`
         <div class="input-group">
            ${this._renderInputGroupText(InputGroupTextType.Prepend)}
            ${this._renderInput()}
            ${this._renderInputGroupText(InputGroupTextType.Append)}
         </div>
      `;
   }
}
